module.exports = __webpack_public_path__ + "media/images/front/icon_check_01-bb0fb057193d71cfaebdfc849a7c4e6e.svg";